import { BetAreaPanel } from './BetArea';
export const PokDengBetAreaPanel = () => {
    return <BetAreaPanel />;
};
